import { render, staticRenderFns } from "./HcbServicesOffered.vue?vue&type=template&id=28f8521e&scoped=true&lang=pug&"
import script from "./HcbServicesOffered.vue?vue&type=script&lang=js&"
export * from "./HcbServicesOffered.vue?vue&type=script&lang=js&"
import style0 from "./HcbServicesOffered.vue?vue&type=style&index=0&id=28f8521e&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f8521e",
  null
  
)

export default component.exports